import React, { FC } from 'react';
import { IconCheckSmall, Typography, TypographyVariantsEnum } from '@mindly/ui-components';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

import { IPromotionalCode } from '../../types';

const PromoCodeItem: FC<IPromotionalCode> = ({ end_date: { _seconds }, percent_off }) => {
  const { t } = useTranslation('profile');

  return (
    <div className={'flex flex-col gap-4 rounded-[30px] p-5 bg-color-background-anti-flash-light'}>
      <div>
        <Typography variant={TypographyVariantsEnum.Text20Semi}>
          {t('discounts.for.trials.title', {
            discount: `${percent_off}%`,
          })}
        </Typography>
        <Typography variant={TypographyVariantsEnum.Text14Regular} opacity={50}>
          {t('discounts.for.trials.description')}
        </Typography>
      </div>
      <div className="border-t border-borders-divider pt-4 flex items-center justify-between">
        <div className="flex items-center gap-1">
          <IconCheckSmall />
          <Typography variant={TypographyVariantsEnum.Text14Regular}>{t('discounts.for.trials.status')}</Typography>
        </div>
        <Typography variant={TypographyVariantsEnum.Text14Regular}>
          {t('discounts.for.trials.expired.date', {
            expiredDate: DateTime.fromSeconds(_seconds).toFormat('dd.MM.yyyy'),
          })}
        </Typography>
      </div>
    </div>
  );
};

export default React.memo(PromoCodeItem);
